import { webModules } from "../../../../../modules/registry.web.ts";

/* Who may open API/AI Usage: anyone who can see at least one section of it.
   The live cards and the Claude API section need signet.usage:view; each
   module's section (HikerAPI) needs its own permission, so the page is open
   to everyone who could open either of the two pages it replaced. The route
   and the entry under More both use this list. */

export const CORE_USAGE_NEEDS = "signet.usage:view";

export const USAGE_NEEDS: string[] = [
  ...new Set([CORE_USAGE_NEEDS, ...webModules.flatMap((mod) => (mod.usagePanels ?? []).map((panel) => panel.needs))]),
];
